import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop
  if (c > 0.5) {
    window.requestAnimationFrame(scrollToTop)
    window.scrollTo(0, c - c / 6)
  }
}

export function useScrollToTop() {
  const location = useLocation()

  useEffect(() => {
    scrollToTop()
  }, [location.pathname])
}
